import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAlert = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M23.4294 1.90386C25.9302 3.03306 27.8312 6.42784 31.6334 13.2174L34.3511 18.0704C38.0059 24.5968 39.8334 27.8601 39.5277 30.5321C39.2611 32.8634 38.0237 34.9743 36.1201 36.3461C33.9379 37.9184 30.1979 37.9184 22.7177 37.9184H17.2824C9.80226 37.9184 6.06221 37.9184 3.88011 36.3461C1.97632 34.9743 0.739103 32.8634 0.472418 30.5321C0.166747 27.8601 1.99416 24.5968 5.64896 18.0704L8.36664 13.2174C12.1688 6.42784 14.0699 3.03306 16.5707 1.90386C18.7509 0.919416 21.2491 0.919416 23.4294 1.90386ZM21.2501 15.0018C21.2501 14.3114 20.6904 13.7518 20.0001 13.7518C19.3096 13.7518 18.7501 14.3114 18.7501 15.0018V21.6684C18.7501 22.3588 19.3096 22.9184 20.0001 22.9184C20.6904 22.9184 21.2501 22.3588 21.2501 21.6684V15.0018ZM20.0001 25.4184C18.8494 25.4184 17.9167 26.3513 17.9167 27.5018C17.9167 28.6524 18.8494 29.5851 20.0001 29.5851C21.1506 29.5851 22.0834 28.6524 22.0834 27.5018C22.0834 26.3513 21.1506 25.4184 20.0001 25.4184Z",
		fill: "#FFC815"
	})
});
export default SvgAlert;
